import api from '../../../services/Api';
import { IAuditoriaDespesaAnaliticaRelevanteResultado } from '../interfaces/IAuditoriaDespesaAnaliticaRelevante';

export const AuditoriaDespesaAnaliticaRelevanteService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaDespesaAnaliticaRelevanteResultado> {
    const response = await api.get<IAuditoriaDespesaAnaliticaRelevanteResultado>('auditoria-despesa-analitica-relevante/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        lancamentosDespesaRelevante: [],
      }
    );
  },
};
